const cards = [
  {
    title: "Catering",
    icon: "ri-service-line",
    problem: "Herkes aynı menüyü yemek zorunda kalır.",
    solution: "Her gün kendi yemeğini sen seçersin.",
  },
  {
    title: "Yemek Platformları",
    icon: "ri-riding-line",
    problem: "Sipariş, kurye ve teslimat sürecini beklersin.",
    solution: "Yemeğin planlanan teslimat için hazırlanır.",
  },
  {
    title: "Evde Pişirme",
    icon: "ri-fridge-line",
    problem: "Alışveriş, hazırlık, pişirme ve bulaşık zaman alır.",
    solution: "Pişirme ve alışveriş zamanı sana kalır.",
  },
];

export default function Differentiators() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-xs font-bold tracking-[0.25em] text-primary-600 uppercase">
            Neden Meliha Sultan?
          </span>
          <h2 className="mt-4 font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            DAYATMA MENÜLERİ YEMEK YERİNE,
            <br />
            SEVDİĞİNİ SEÇ.
          </h2>
          <p className="mt-4 text-foreground-600 leading-relaxed">
            Mesele sadece yemek değil. Seçim özgürlüğü, sıcaklık, düzen ve ev
            yemeği hissi.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {cards.map((card) => (
            <div
              key={card.title}
              className="group bg-background-50 border border-background-200 rounded-lg p-7 hover:-translate-y-1.5 hover:border-primary-200 transition-all cursor-default"
            >
              <div className="w-12 h-12 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center">
                <i className={`${card.icon} text-2xl`}></i>
              </div>
              <h3 className="mt-5 font-heading text-2xl font-bold text-foreground-950">
                {card.title}
              </h3>
              <div className="mt-5 space-y-3">
                <div className="flex items-start gap-3">
                  <div className="mt-0.5 w-5 h-5 rounded-full bg-foreground-100 text-foreground-500 flex items-center justify-center shrink-0">
                    <i className="ri-close-line text-sm"></i>
                  </div>
                  <p className="text-sm text-foreground-600">{card.problem}</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="mt-0.5 w-5 h-5 rounded-full bg-primary-500 text-background-50 flex items-center justify-center shrink-0">
                    <i className="ri-check-line text-sm"></i>
                  </div>
                  <p className="text-sm font-semibold text-foreground-900">
                    {card.solution}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}